function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#4293F6",
  d: "M13.15 5.467L47.67 0l34.52 5.467.472 23.87a55 55 0 0 1-29.755 49.959L47.67 82l-5.237-2.704a55 55 0 0 1-29.755-49.959l.473-23.87z",
  opacity: 0.1
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#2F66E3",
  fillRule: "evenodd",
  d: "M41.4 26.737V30.7h-1.88c-.546 0-1 .457-1 1.006v10.396h8.52v-2.195c0-.61.485-1.098 1.091-1.098a1.09 1.09 0 0 1 1.092 1.098v2.195h8.522V31.706c0-.549-.454-1.006-1-1.006h-1.941v-3.963c0-3.719-3.002-6.737-6.702-6.737S41.4 23.018 41.4 26.737zM52.378 30.7h-8.491v-4.298c0-2.348 1.88-4.268 4.245-4.268 2.366 0 4.246 1.89 4.246 4.268V30.7zm6.277 23.93H37.55c-3.062 0-5.549-2.499-5.549-5.578v-.396c0-3.08 2.487-5.579 5.55-5.579h21.105c3.063 0 5.55 2.5 5.55 5.579v.396c.03 3.08-2.487 5.579-5.55 5.579zm-19.661-8.26c.251 0 .455.204.455.457v1.342l1.156-.671a.454.454 0 0 1 .62.167.459.459 0 0 1-.166.625l-1.156.67 1.157.672a.459.459 0 0 1 .166.624.454.454 0 0 1-.621.168l-1.156-.671v1.342a.456.456 0 0 1-.455.457.456.456 0 0 1-.455-.457v-1.342l-1.156.67a.454.454 0 0 1-.622-.167.459.459 0 0 1 .167-.624l1.156-.671-1.156-.671a.459.459 0 0 1-.167-.625.454.454 0 0 1 .622-.167l1.156.67v-1.341c0-.253.204-.457.455-.457zm6.065 0c.251 0 .455.204.455.457v1.342l1.155-.671a.453.453 0 0 1 .622.167.459.459 0 0 1-.167.625l-1.156.67 1.156.672a.459.459 0 0 1 .167.624.454.454 0 0 1-.621.168l-1.156-.671v1.342a.456.456 0 0 1-.455.457.456.456 0 0 1-.455-.457v-1.342l-1.156.67a.454.454 0 0 1-.622-.167.459.459 0 0 1 .167-.624l1.156-.671-1.156-.671a.459.459 0 0 1-.167-.625.454.454 0 0 1 .622-.167l1.156.67v-1.341c0-.253.203-.457.455-.457zm6.065 0c.25 0 .455.204.455.457v1.342l1.155-.671a.454.454 0 0 1 .622.167.459.459 0 0 1-.167.625l-1.156.67 1.156.672a.459.459 0 0 1 .167.624.454.454 0 0 1-.622.168l-1.155-.671v1.342a.456.456 0 0 1-.455.457.456.456 0 0 1-.455-.457v-1.342l-1.156.67a.454.454 0 0 1-.622-.167.459.459 0 0 1 .167-.624l1.156-.671-1.156-.671a.459.459 0 0 1-.167-.625.454.454 0 0 1 .622-.167l1.156.67v-1.341c0-.253.204-.457.455-.457zm6.065 0c.25 0 .455.204.455.457v1.342l1.155-.671a.454.454 0 0 1 .622.167.459.459 0 0 1-.167.625l-1.156.67 1.156.672a.459.459 0 0 1 .167.624.454.454 0 0 1-.622.168l-1.155-.671v1.342a.456.456 0 0 1-.455.457.456.456 0 0 1-.455-.457v-1.342l-1.157.67a.454.454 0 0 1-.62-.167.459.459 0 0 1 .166-.624l1.156-.671-1.156-.671a.459.459 0 0 1-.167-.625.453.453 0 0 1 .622-.167l1.156.67v-1.341c0-.253.203-.457.455-.457z",
  clipRule: "evenodd",
  filter: "url(#a)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "a",
  width: 96.21,
  height: 98.63,
  x: 0,
  y: 20,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 4
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.203922 0 0 0 0 0.368627 0 0 0 0 0.662745 0 0 0 0.15 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  mode: "multiply",
  result: "effect1_dropShadow"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 8
}), React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.203922 0 0 0 0 0.368627 0 0 0 0 0.662745 0 0 0 0.15 0"
}), React.createElement("feBlend", {
  in2: "effect1_dropShadow",
  mode: "multiply",
  result: "effect2_dropShadow"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 16
}), React.createElement("feGaussianBlur", {
  stdDeviation: 8
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.203922 0 0 0 0 0.368627 0 0 0 0 0.662745 0 0 0 0.15 0"
}), React.createElement("feBlend", {
  in2: "effect2_dropShadow",
  mode: "multiply",
  result: "effect3_dropShadow"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 32
}), React.createElement("feGaussianBlur", {
  stdDeviation: 16
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.203922 0 0 0 0 0.368627 0 0 0 0 0.662745 0 0 0 0.15 0"
}), React.createElement("feBlend", {
  in2: "effect3_dropShadow",
  mode: "multiply",
  result: "effect4_dropShadow"
}), React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect4_dropShadow",
  result: "shape"
})));

var SvgLockShield = function SvgLockShield(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 97,
    height: 119,
    fill: "none",
    viewBox: "0 0 90 100",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLockShield, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock-shield.643f9018.svg";
export { ForwardRef as ReactComponent };